import { CustomBottomBar, CustomPageTitle, PointageDetails, PointageTask } from '@components';
import { Button, Container, Typography } from '@design-system';
import React from 'react';
import { BiPlus } from 'react-icons/bi';
import { MdTimer } from 'react-icons/md';
import { usePointageActionPageVM } from './usePointageActionPageVM';

export const PointageActionPage: React.FC = () => {
    const {
        day,
        tasks,
        tasksTypes,
        operators,
        handleTaskChange,
        handleCreateNewTask,
        handleTaskDelete,
        handleValidate,
        areTasksFilled,
        isUsageVehiculeChecked,
        setIsUsageVehiculeChecked,
        comment,
        setComment,
        areTasksAlreadyValidated
    } = usePointageActionPageVM();

    return (
        <>
            {day && (
                <CustomPageTitle>
                    <Typography intrinsic="h3" iconColor="yellow" icon={<MdTimer />} iconFilled iconSize={20}>
                        <>
                            {new Date(day.date)
                                .toLocaleDateString('fr-FR', {
                                    weekday: 'long',
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: '2-digit'
                                })
                                .replace(/\//g, '/')}
                        </>
                    </Typography>
                </CustomPageTitle>
            )}

            <Container>
                <Typography intrinsic="h2">Tâches du jour</Typography>

                {tasks?.map((task, index) => (
                    <PointageTask
                        key={task.id || index}
                        taskId={task.id || index + 1}
                        initialTask={task}
                        onTaskChange={handleTaskChange}
                        onTaskDelete={handleTaskDelete}
                        tasksTypes={tasksTypes}
                        operators={operators}
                        summedHours={tasks.filter((t) => t.id !== task.id).reduce((acc, task) => acc + Number(task.hours), 0)}
                        taskState={task.state_id}
                        index={index}
                    />
                ))}

                {!areTasksAlreadyValidated && (
                    <Container padding="none" center>
                        <Button
                            color="green"
                            variant="secondary"
                            size="small"
                            icon={<BiPlus />}
                            iconSize={22}
                            onClick={handleCreateNewTask}
                        >
                            <Typography intrinsic="h4">Ajouter une tâche</Typography>
                        </Button>
                    </Container>
                )}

                <PointageDetails
                    isUsageVehiculeChecked={isUsageVehiculeChecked}
                    setIsUsageVehiculeChecked={setIsUsageVehiculeChecked}
                    comment={comment}
                    setComment={setComment}
                />
            </Container>

            <CustomBottomBar>
                <Button color="marine" variant="primary" size="fullwidth" onClick={handleValidate} disabled={!areTasksFilled}>
                    <Typography intrinsic="h4">Valider cette journée</Typography>
                </Button>
            </CustomBottomBar>
        </>
    );
};
